import { borderRadius, Box } from "@mui/system";
import RootComponents from "../../components/common/RootComponents";
import styles from "./Invite.module.css";
import search_resume from "../../assets/images/group-people-working-books.png";
import { CircularProgress, Typography } from "@mui/material";
import { useEffect } from "react";
import { getProfile } from "../../redux/profile/profileSlice";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { sendInvite } from "../../redux/invite/inviteSlice";
import image from "../../assets/images/Invite Img.jpg";

const Invite = () => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile?.data);
  const inviteStatus = useSelector((state) => state.invite?.status);

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      copyemail: "",
    },
    validationSchema: Yup.object({
      copyemail: Yup.string().required("Add some email id to send invite"),
    }),
    onSubmit: (values) => {
      const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
      const validEmails = values.copyemail.match(emailRegex) || [];

      if (validEmails.length === 0) {
        alert("No valid email addresses found");
        return;
      }

      console.log({ validEmails });

      let joinLink = "";
      if (profile?.profile?.role === "BENCH_SALES_RECRUITER") {
        joinLink = "https://povital.com/it-recruiter-signup";
      } else {
        joinLink = "https://povital.com/benchsales-signup";
      }

      let userData = {
        new_user_emails: validEmails,
        refer_name: profile?.profile?.full_name,
        refer_company: profile?.profile?.company_name,
        join_link: joinLink,
      };

      dispatch(sendInvite(userData));
    },
  });

  useEffect(() => {
    if (inviteStatus === "sent_invitation_succeeded") {
      formik.resetForm({
        values: {
          copyemail: "",
        },
      });
    }
  }, [inviteStatus]);

  const autoResize = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto"; // Reset the height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set it to match content
    }
  };

  return (
    // <RootComponents>
    <Box className={styles.invite_stucture}>
      <Box className={styles.header_section}>
        <Box>
          <Typography sx={{ fontSize: "26px !important" }}>
            <b>Invite to Bench Sales Recruiter</b>
          </Typography>

          <Typography sx={{ fontSize: "18px !important" }}>
            To work together from next job requirement with AI powered portal.
          </Typography>
          <Typography sx={{ fontSize: "18px !important" }}>
            Don’t make the limitation of your achievement.
          </Typography>
        </Box>

        <Box>
          <img src={image} alt="" />
        </Box>
      </Box>
      <form onSubmit={formik.handleSubmit}>
        <Box style={{ border: "1px solid #d1d5db", borderRadius: "3px" }}>
          <textarea
            name="copyemail"
            placeholder="Copy & paste email address"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.copyemail}
            rows="5"
            cols="50"
            onInput={(event) => autoResize(event.target)}
            ref={(el) => el && autoResize(el)}
            style={{
              width: "100%",
              padding: "14px",
              overflow: "hidden",
              resize: "none",
              border: "none",
            }}
          ></textarea>
        </Box>
        {formik.touched.copyemail && formik.errors.copyemail ? (
          <div className="login_error" style={{ marginLeft: "20px" }}>
            {formik.errors.copyemail}
          </div>
        ) : null}
      </form>
      <Typography sx={{ marginTop: "4px" }}>
        NB: Maximum invitation 1000 in a single click.
      </Typography>
      <Box className={styles.invite_btns}>
        <button
          type="submit"
          onClick={formik.handleSubmit}
          style={inviteStatus === "loading" ? { padding: "7px 40px" } : {}}
        >
          {inviteStatus === "loading" ? (
            <CircularProgress size={12} sx={{ color: "#fff" }} />
          ) : (
            "Send Invitation"
          )}
        </button>
      </Box>
    </Box>
    // </RootComponents>
  );
};
export default Invite;
